export enum DBTables {
    Webhook = 'webhook',
    Contacts = 'contacts',
    Messages = 'messages',
    MessageTemplate = 'message_template',
    Setup = 'setup',
    Support = 'support',
    Profile = 'profiles',
    Dealer = 'dealer',
    Sales = 'sales',
    QRCodes = 'qr_codes',
    QRType = 'qr_type',
    Customers = 'customers',
}